<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="pt-0">
    <h3 class="font-weight-bolder mb-2 d-flex align-items-center justify-content-between">
      Your Details
    </h3>

    <section class="mb-2">
      <label class="font-weight-bolder">Name</label>
      <p class="mb-0">{{profile.name}}</p>
    </section>
    <section class="mb-2">
      <label class="font-weight-bolder">Username</label>
      <p class="mb-0">{{profile.username}}</p>
    </section>
    <section class="mb-2" v-if="profile.email">
      <label class="font-weight-bolder">Email</label>
      <p class="mb-0">{{profile.email}}</p>
    </section>

  </section>
</template>
<!--eslint-enable-->

<script>

export default {
  name: 'ProfileDetails',
  components: {},
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
};
</script>
